// (function(Wishlist, $) {

//     // var $wishlistButton = $('.wishlist-btn');
//     var $wishlistButton = $('.wishlist-btn, .btn-wishlist');
//     var $wishlistTile = $('.wishlist-tile-container');
//     var $wishlistItemCount = $('.wishlist-item-count');
//     var numProductTiles = $wishlistTile.length;
//     var wishlist = localStorage.getItem('user_wishlist') || [];
//     if (wishlist.length > 0) {
//         wishlist = JSON.parse(localStorage.getItem('user_wishlist'));
//     }

//     /*
//      * Update button to show current state (gold for active)
//      */
//     var animateWishlist = function(self) {
//         $(self).toggleClass('is-active');
//     };

//     /*
//      * Add/Remove selected item to the user's wishlist array in localStorage
//      * Wishlist button class 'is-active' determines whether or not to add or remove
//      * If 'is-active', remove the item, otherwise add it
//      */
//     var updateWishlist = function(self) {
//         var productHandle = $(self).attr('data-product-handle');
//         var isRemove = $(self).hasClass('is-active');
//         /* Remove */
//         if (isRemove) {

//             var removeIndex = wishlist.indexOf(productHandle);
//             wishlist.splice(removeIndex, 1);
//             localStorage.setItem('user_wishlist', JSON.stringify(wishlist));
//         }
//         /* Add */
//         else {
//             wishlist.push(productHandle);
//             localStorage.setItem('user_wishlist', JSON.stringify(wishlist));
//         }

//     };

//     /*
//      * Loop through wishlist buttons and activate any items that are already in user's wishlist
//      * Activate by adding class 'is-active'
//      * Run on initialization
//      */
//     var activateItemsInWishlist = function() {
//         $wishlistButton.each(function() {
//             var productHandle = $(this).attr('data-product-handle');
//             if (wishlist.indexOf(productHandle) > -1) {
//                 $(this).addClass('is-active');
//             }
//         });
//     };

//     /*
//      * Loop through product titles and remove any that aren't a part of the wishlist
//      * Decrement numProductTiles on removal
//      */
//     var displayOnlyWishlistItems = function() {
//         $wishlistTile.each(function() {
//             var productHandle = $(this).attr('data-product-handle');
//             if (wishlist.indexOf(productHandle) === -1) {
//                 $(this).remove();
//                 numProductTiles--;
//             }
//         });
//     };

//     /*
//      * Check if on the wishlist page and hide any items that aren't a part of the wishlist
//      * If no wishlist items exist, show the empty wishlist notice
//      */
//     var loadWishlist = function() {
//         displayOnlyWishlistItems();
//             $('.wishlist-grid').addClass('is_visible');
//             $('.wishlist-hero').addClass('is_visible');
//             if (numProductTiles == 0) {
//                 $('.wishlist-grid--empty-list').addClass('is_visible');
//             } else {
//                 $('.wishlist-grid--empty-list').hide();
//             }
//     };

//     /*
//      * Display number of items in the wishlist
//      * Must set the $wishlistItemCount variable
//      */
//     var updateWishlistItemCount = function() {
//         if (wishlist) {
//             $wishlistItemCount.text(wishlist.length + '');
//         }
//     };

//     var bindUIActions = function() {
//         $wishlistButton.click(function(e) {
//           console.log("vbghfhguy")
//             e.preventDefault();
//             setTimeout(function() { window.location.href = '/pages/wishlist'; });
//             updateWishlist(this);
//             animateWishlist(this);
//         });
//     };

//     Wishlist.init = function() {
//         bindUIActions();
//         activateItemsInWishlist();
//         loadWishlist();
//         updateWishlistItemCount();
//     };

// }(window.Wishlist = window.Wishlist || {}, jQuery, undefined));



(function(Wishlist, $) {

    var $wishlistButton = $('.wishlist-btn');
    var $wishlistTile = $('.wishlist-tile-container');
    var $wishlistItemCount = $('.wishlist-item-count');
    var numProductTiles = $wishlistTile.length;
    var wishlist = localStorage.getItem('user_wishlist') || [];
    if (wishlist.length > 0) {
        wishlist = JSON.parse(localStorage.getItem('user_wishlist'));
    }

    /*
     * Update button to show current state (gold for active)
     */
    var animateWishlist = function(self) {
        $(self).toggleClass('is-active');
    };

    /*
     * Add/Remove selected item to the user's wishlist array in localStorage
     * Wishlist button class 'is-active' determines whether or not to add or remove
     * If 'is-active', remove the item, otherwise add it
     */
    var updateWishlist = function(self) {
        var productHandle = $(self).attr('data-product-handle');
        var isRemove = $(self).hasClass('is-active');
        /* Remove */
        if (isRemove) {

            var removeIndex = wishlist.indexOf(productHandle);
            wishlist.splice(removeIndex, 1);
            localStorage.setItem('user_wishlist', JSON.stringify(wishlist));
        }
        /* Add */
        else {
            wishlist.push(productHandle);
            localStorage.setItem('user_wishlist', JSON.stringify(wishlist));
        }

    };

    /*
     * Loop through wishlist buttons and activate any items that are already in user's wishlist
     * Activate by adding class 'is-active'
     * Run on initialization
     */
    var activateItemsInWishlist = function() {
        $wishlistButton.each(function() {
            var productHandle = $(this).attr('data-product-handle');
            if (wishlist.indexOf(productHandle) > -1) {
                $(this).addClass('is-active');
            }
        });
    };

    /*
     * Loop through product titles and remove any that aren't a part of the wishlist
     * Decrement numProductTiles on removal
     */
    var displayOnlyWishlistItems = function() {
        $wishlistTile.each(function() {
            var productHandle = $(this).attr('data-product-handle');
            if (wishlist.indexOf(productHandle) === -1) {
                $(this).remove();
                numProductTiles--;
            }
        });
    };

    /*
     * Check if on the wishlist page and hide any items that aren't a part of the wishlist
     * If no wishlist items exist, show the empty wishlist notice
     */
    var loadWishlist = function() {
        displayOnlyWishlistItems();
            $('.wishlist-grid').addClass('is_visible');
            $('.wishlist-hero').addClass('is_visible');
            if (numProductTiles == 0) {
                $('.wishlist-grid--empty-list').addClass('is_visible');
            } else {
                $('.wishlist-grid--empty-list').hide();
            }
    };

    /*
     * Display number of items in the wishlist
     * Must set the $wishlistItemCount variable
     */
    var updateWishlistItemCount = function() {
        if (wishlist) {
            $wishlistItemCount.text(wishlist.length + '');
        }
    };

    var bindUIActions = function() {
        $wishlistButton.click(function(e) {
          console.log("vbghfhguy")
            e.preventDefault();
            setTimeout(function() { window.location.href = '/pages/wishlist'; });
            updateWishlist(this);
            animateWishlist(this);
        });
    };

    Wishlist.init = function() {
        bindUIActions();
        activateItemsInWishlist();
        loadWishlist();
        updateWishlistItemCount();
    };

}(window.Wishlist = window.Wishlist || {}, jQuery, undefined));